// extracted by mini-css-extract-plugin
module.exports = {"main_container":"GateWallet_main_container__36OGo","first_section":"GateWallet_first_section__3cZhu","checkbox":"GateWallet_checkbox__2WHmv"};